import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen flex items-center justify-center">
      <div className="text-center">
        {/* Animated Logo */}
        <div className="relative mb-8">
          <img 
            src="https://res.cloudinary.com/durgvddoz/image/upload/v1754228067/LOGOCYBERHIGH_axauvq.png" 
            alt="CyberSoft Logo" 
            className="h-20 w-auto mx-auto"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 border-2 border-blue-600 border-t-transparent rounded-full animate-spin-slow"></div>
          </div>
        </div>
        
        {/* Loading Text */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-white">CyberSoft</h2>
          <p className="text-blue-400 text-lg">Securing Your Digital Future</p>
          
          {/* Loading Dots */}
          <div className="flex justify-center space-x-1 mt-4">
            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse"></div>
            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse"></div>
            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-pulse"></div>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="mt-8 w-64 mx-auto">
          <div className="w-full bg-slate-800 rounded-full h-1">
            <div className="bg-blue-500 h-1 rounded-full w-3/4"></div>
          </div>
        </div>
      </div>
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
        <div className="absolute top-10 left-10 w-20 h-20 bg-blue-500 rounded-full blur-2xl"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-blue-400 rounded-full blur-xl"></div>
      </div>
    </div>
  );
};

export default LoadingScreen;